import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MenuPage from './pages/MenuPage';
import ManagerDashboard from './pages/ManagerMenuDashboard';
import Login from './pages/Login';
import ThemeConfigPage from './components/dashboardComponents/StoreSettings/ThemeConfigPage';
import ConfigLayout from './layouts/ConfigLayout';
import WorkingHoursManager from './components/dashboardComponents/StoreSettings/WorkingHoursManager';
import ConfigurationManager from './components/dashboardComponents/StoreSettings/ConfigurationManager';
import { ProtectedRoute } from './auth';
import AccessibilityDeclaration from './components/Accessibility/AccessibilityDeclaration';

const AppRoutes = ({ handleLogin }) => {
  const useProtectedRoutes = true; // Set to true to enable ProtectedRoute

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Navigate to="/menu" />} />
      <Route path="/menu" element={<MenuPage />} />
      <Route path="/login" element={<Login onLogin={handleLogin} />} />

      {/* Conditionally Protected Routes */}
      <Route
        path="/dashboard"
        element={
          useProtectedRoutes ? (
            <ProtectedRoute>
              <ManagerDashboard />
            </ProtectedRoute>
          ) : (
            <ManagerDashboard />
          )
        }
      />

      {/* Conditionally Protected Config Routes */}
      <Route
        path="/config"
        element={
          useProtectedRoutes ? (
            <ProtectedRoute>
              <ConfigLayout />
            </ProtectedRoute>
          ) : (
            <ConfigLayout />
          )
        }
      >
        <Route index element={<Navigate to="configurations" replace />} />
        <Route path="theme" element={<ThemeConfigPage />} />
        <Route path="hours" element={<WorkingHoursManager />} />
        <Route path="configurations" element={<ConfigurationManager />} />
      </Route>
      <Route path="/accessibility" element={<AccessibilityDeclaration />} />

      {/* Legacy Route Redirects */}
      <Route
        path="/theme-config"
        element={<Navigate to="/config/theme" replace />}
      />
    </Routes>
  );
};

export default AppRoutes;
